module.exports = __webpack_public_path__ + "media/images/icon_btn_good-bbe94c1d73f2c4346e54bd865814f6da.png";